"use strict";
// tslint:disable:no-console
exports.__esModule = true;
exports.forAllImagesInElement = void 0;
function forAllImagesInElement(element) {
    return Promise.all(Array.from(element.querySelectorAll('img')).map(function (imageElement /*, i*/) {
        // TODO: BEFORE ANY CHANGE HERE forAllImagesInElement should be internally using forImage
        return new Promise(function (resolve, reject) {
            if (imageElement.complete) {
                if (imageElement.naturalHeight === 0) {
                    /*
                    TODO: [0]
                    console.info(
                        `Image ${i} rejected due to 0 naturalHeight`,
                    );
                    */
                    // TODO: Check this also in load
                    reject(imageElement);
                }
                else {
                    // TODO: [0]> console.info(`Image ${i} is already completed`);
                    resolve();
                }
            }
            imageElement.addEventListener('load', function () {
                // TODO: [0]> console.info(`Image ${i} resolved`);
                resolve();
            });
            imageElement.addEventListener('error', function () {
                // TODO: [0]> console.info(`Image ${i} rejected`);
                reject(new Error("Some images can`t be loaded."));
            });
        });
    })).then(function () {
        /* Note: Returning void */
    });
}
exports.forAllImagesInElement = forAllImagesInElement;
/**
 * TODO: forAllImagesInElement should be internally using forImage
 * TODO: forAllImagesInElement should be able to recieve just an <img> element
 * TODO: Rename to forImagesReady OR forMediaReady
 * TODO: Timeout by chaining
 * TODO: rejectWhenNotLoaded by chaining
 * TODO: Corrupted images into samples
 * TODO: Also with media and pictures
 * TODO: Universal for every loadable think
 * TODO: Also start new wait when  new images appears / disappears during the wait
 * TODO: [0] Verbose mode for logging
 * TODO: Make special error - ImageError and put imgElement as extra data of ImageError
 */
